<h2 mat-dialog-title>Build-Informationen</h2>

<mat-dialog-content>
  <div class="info-container">
    <div class="info-section">
      <h4 class="section-title">
        <mat-icon>desktop_windows</mat-icon>
        <span>Frontend</span>
      </h4>
      <p><strong>Version:</strong> {{ frontendInfo.version }}</p>
      <p><strong>Build-Zeit:</strong> {{ frontendInfo.time | date: 'dd.MM.yyyy HH:mm:ss' }}</p>
    </div>

    <div class="info-section">
      <h4 class="section-title">
        <mat-icon>dns</mat-icon>
        <span>Backend</span>
      </h4>
      @if (isLoading) {
        <mat-spinner diameter="30"></mat-spinner>
      } @else {
        <p><strong>Version:</strong> {{ backendInfo?.version }}</p>
        <p><strong>Build-Zeit:</strong> {{ backendInfo?.time | date: 'dd.MM.yyyy HH:mm:ss' }}</p>
      }
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  @if (updateService.updateAvailable()) {
    <button mat-flat-button color="primary" (click)="updateService.applyUpdate()" style="width: 100%">
      <mat-icon>system_update</mat-icon>
      Update anwenden
    </button>
  }
  <button mat-stroked-button (click)="reloadPage()" style="width: 100%">
    <mat-icon>refresh</mat-icon>
    Seite neu laden
  </button>
</mat-dialog-actions>

<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true">Schließen</button>
</mat-dialog-actions>
